var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7495 15.2096H12.4912C12.1495 15.2096 11.8662 14.9263 11.8662 14.5846C11.8662 14.243 12.1495 13.9596 12.4912 13.9596H13.7495C15.9329 13.9596 17.7079 12.1846 17.7079 10.0013C17.7079 7.81797 15.9329 6.04297 13.7495 6.04297H12.4995C12.1579 6.04297 11.8745 5.75964 11.8745 5.41797C11.8745 5.0763 12.1495 4.79297 12.4995 4.79297H13.7495C16.6245 4.79297 18.9579 7.1263 18.9579 10.0013C18.9579 12.8763 16.6245 15.2096 13.7495 15.2096Z",
    fill: "#5E01D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 15.2096H6.25033C3.37533 15.2096 1.04199 12.8763 1.04199 10.0013C1.04199 7.1263 3.37533 4.79297 6.25033 4.79297H7.50033C7.84199 4.79297 8.12533 5.0763 8.12533 5.41797C8.12533 5.75964 7.84199 6.04297 7.50033 6.04297H6.25033C4.06699 6.04297 2.29199 7.81797 2.29199 10.0013C2.29199 12.1846 4.06699 13.9596 6.25033 13.9596H7.50033C7.84199 13.9596 8.12533 14.243 8.12533 14.5846C8.12533 14.9263 7.84199 15.2096 7.50033 15.2096Z",
    fill: "#5E01D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 10.625H6.66699C6.32533 10.625 6.04199 10.3417 6.04199 10C6.04199 9.65833 6.32533 9.375 6.66699 9.375H13.3337C13.6753 9.375 13.9587 9.65833 13.9587 10C13.9587 10.3417 13.6753 10.625 13.3337 10.625Z",
    fill: "#5E01D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.fac2be9e5544f453188df654857c2f76.svg";
export { ForwardRef as ReactComponent };